import { render, staticRenderFns } from "./smt.vue?vue&type=template&id=345d061c&scoped=true"
import script from "./smt.vue?vue&type=script&lang=js"
export * from "./smt.vue?vue&type=script&lang=js"
import style0 from "./smt.vue?vue&type=style&index=0&id=345d061c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d061c",
  null
  
)

export default component.exports